
export interface HasHostedImageURL {
  hosted_image_url?: string,
}

declare const RASA_IMGIX_URL_UI: string

export const imgixUrlForUrl = (
  url: string, height: number, width: number = null, crop = true , resize = true): string => {
  const u: string = url
  if (u) {
    const params = []
    if (resize) {
      params.push(`h=${height}`)
      if (width) {
        params.push(`w=${width}`)
      }
      if (crop) {
        params.push('fit=crop')
        params.push('crop=entropy')
      }
    }
    let resultUrl = `${u.replace('hosted-images-newsbrief.s3.amazonaws.com', RASA_IMGIX_URL_UI)}`
    if (params.length) {
      if (resultUrl.indexOf('?') > -1) {
        resultUrl += `&${params.join('&')}`
      } else {
        resultUrl += `?${params.join('&')}`
      }
    }
    return resultUrl
  } else {
    return null
  }
}

export const imgixUrlForStatic = (url: string, width: number = null) => {
  if (url) {
    return `${url.replace('hosted-images-newsbrief.s3.amazonaws.com', RASA_IMGIX_URL_UI)}`
  } else {
    return null
  }
}

export const isHostedImage = (url: string): boolean => {
  return (url || '').includes('hosted-images-newsbrief.s3.amazonaws.com')
}

// Easier to use than URLSearchParams
// https://stackoverflow.com/questions/8648892/convert-url-parameters-to-a-javascript-object
export const queryStringAsParams = (queryString: string): any => {
  if (queryString && queryString.length > 0) {
    const s = '{"' + decodeURI(queryString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}'
    return JSON.parse(s)
  } else {
    return {}
  }
}

export const parseHref = (href: string) => {
  href = href || ''
  const parts = href ? href.split('?') : []
  const params = parts.length <= 1 ? {} :
    parts[1].split('#').length > 1 ? parts[1].split('#')[0] : queryStringAsParams(parts[1])
  const hash = href.split('#').length > 1 ? href.split('#')[1] : ''
  const route = parts[0].split('#')[0]
  return {
    hash,
    params,
    route,
  }
}
